import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { IndustryService } from '../services/industry.service'

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-courses',
    templateUrl: './courses.component.html',
    animations: [fadeInUp]
})
export class CoursesPageComponent implements OnInit, OnDestroy {
    industrySlug: any
    industries: any
    industry: any
    careerSlug: any
    career: any
    courses: any
    industriesSubscription: any
    paramsSubscription: any

    constructor(
        private route: ActivatedRoute,
        private industryService: IndustryService,
        private title: Title
    ) {
        this.paramsSubscription = this.route.params.subscribe(params => {
            const industry = params.industry
            const career = params.career

            let industryTitle = this.industryService.getTitleString(industry)
            let careerTitle = this.industryService.getTitleString(career)

            const title = careerTitle + ' | ' + industryTitle

            this.title.setTitle(title)
        })
    }

    ngOnInit() {
        this.industrySlug = this.route.snapshot.params['industry']
        this.careerSlug = this.route.snapshot.params['career']

        this.industryService.getIndustries()
        this.industriesSubscription = this.industryService.Industries.subscribe(industries => {
            if (industries && industries.length > 0) {

				this.industries = industries.filter(elem => {
					if (elem.slug === this.industrySlug) {
						this.industry = elem
						return false
					} else {
						return true
					}
				})

				// Shuffle array
				this.industries = this.industries.sort(() => 0.5 - Math.random());
				// Get sub-array of first n elements after shuffled
				this.industries = this.industries.slice(0, 2);
            }
        })

        this.industryService.getCareerBySlug(this.careerSlug).subscribe(career => {
            this.career = career.json()
            this.getCourses()
        }, err => {
            console.log(err);
        })
    }

    ngOnDestroy() {
        if (this.industriesSubscription) {
            this.industriesSubscription.unsubscribe()
        }
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe()
        }
    }

    getCourses() {
        this.industryService.getCoursesByCareerId(this.career['_id']).subscribe(courses => {
            this.courses = courses.json()
        }, err => {
            console.log(err);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/industries/courses.component.ts